import { render, staticRenderFns } from "./ztzl_details.vue?vue&type=template&id=1617bf73&scoped=true&"
import script from "./ztzl_details.vue?vue&type=script&lang=js&"
export * from "./ztzl_details.vue?vue&type=script&lang=js&"
import style0 from "./ztzl_details.vue?vue&type=style&index=0&id=1617bf73&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1617bf73",
  null
  
)

export default component.exports